<ion-header>
  <app-navheader [page]="isLogin()"></app-navheader>
  <img src="/../assets/img/black-arrow-login.png" class="black-arrow-login"/>
</ion-header>
<ion-content class="ion-no-padding">
  <ion-item lines="none" class="header blue-item">
  	<h1 class="h1-blue-page"> {{'ACCOUNT_CREATION.CREER_COMPTE' | translate}} </h1>
  </ion-item>
  <div class="wrapper">
    <ion-list class="ion-no-padding">
      <form #createUserForm ="ngForm">
        <ion-item lines="none" class="blue-item ion-no-padding">
          <ion-label position="stacked">{{ 'ACCOUNT_CREATION.LABELS.PRENOM' | translate }}</ion-label>
          <ion-input required (ionBlur)="checkOnBlurNumbers()" [(ngModel)]="model.firstName" name="firstName" [ngClass] = "{'emailvalidation': !numberValidation && userstatusNumbers}" type="text" #firstName = "ngModel"></ion-input>
        </ion-item>
        <div class="errortext" [ngClass]= "{'visible': !numberValidation && userstatusNumbers}">{{ 'ERROR.GENERIC.ONLY_LETTERS' | translate }}</div>
        <div class="errortextpassword" [hidden]= "firstName.valid || firstName.pristine">{{ 'ERROR.LOGIN.REQUIRED' | translate }}</div>

        <ion-item lines="none" class="blue-item ion-no-padding">
          <ion-label  position="stacked">{{ 'ACCOUNT_CREATION.LABELS.NOM' | translate }}</ion-label>
          <ion-input required (ionBlur)="checkOnBlurNumbersName()" [(ngModel)]="model.lastName" name="lastName"  [ngClass] = "{'emailvalidation': !numberValidationName && userstatusNumbersName}" type="text" #lastName = "ngModel"></ion-input>
        </ion-item>
        <div class="errortext" [ngClass]= "{'visible': !numberValidationName && userstatusNumbersName}">{{ 'ERROR.GENERIC.ONLY_LETTERS' | translate }}</div>
        <div class="errortextpassword" [hidden]= "lastName.valid || lastName.pristine">{{ 'ERROR.LOGIN.REQUIRED' | translate }}</div>

        <ion-item lines="none" class="blue-item ion-no-padding">
          <ion-label  position="stacked">{{ 'ACCOUNT_CREATION.LABELS.EMAIL' | translate }}</ion-label>
          <ion-input required (ionBlur)="checkOnBlur()" [(ngModel)]="model.email" name="email" [ngClass] = "{'ng-invalid': error.email, 'ng-dirty': error.email, 'emailvalidation': !validation && userstatus}" type="text" #email = "ngModel"></ion-input>
        </ion-item>
        <div class="errortext" [ngClass]= "{'visible': error.email}">{{ 'ERROR.PROFILE_CREATOR.EMAIL_DEJA_UTILISE' | translate }}</div>
        <div class="errortext" [ngClass]= "{'visible': !validation && userstatus}">{{ 'ERROR.EMAIL.INVALID' | translate }}</div>
        <div class="errortextpassword" [hidden]= "email.valid || email.pristine">{{ 'ERROR.LOGIN.REQUIRED' | translate }}</div>

        <ion-item lines="none" class="profile-password blue-item ion-no-padding">
          <ion-label position="stacked">{{ 'ACCOUNT_CREATION.LABELS.MOT_DE_PASSE_FAMILLE' | translate}}</ion-label>
          <ion-input (ionBlur)="checkOnBlur3()" required [(ngModel)]="model.plainPassword" [ngClass] = "{'ng-invalid': error.password, 'ng-dirty': error.password, 'emailvalidation': !validation3 && userstatus3}" [type] = "this.showPassword1 ? 'text' : 'password'" name="plainPassword" #plainPassword = "ngModel"></ion-input>
        </ion-item>
        <div class="eye-wrapper">
          <span [ngClass]="{'eye': true, 'eye-crossed': this.showPassword1}" (click)="togglePassword(1)"></span>
        </div>
        <div class="qmarkwrapper"> <img (click)="presentPopover($event)" class="qmark" src="../../../assets/img/qmark.png" /></div>
        <div class="errortext" [ngClass]= "{'visible': error.password}">{{error.message}}</div>
        <div class="errortextpassword" [hidden]= "plainPassword.valid || plainPassword.pristine">{{ 'ERROR.LOGIN.REQUIRED' | translate }}</div>
        <div class="errortext" [ngClass]= "{'visible': !validation3 && userstatus3}">{{ 'ERROR.RESET_PASSWORD.PASSWORD_CRITERIA' | translate }}</div>
        <ion-item lines="none" class="blue-item ion-no-padding">
          <ion-label  position="stacked">{{ 'ACCOUNT_CREATION.LABELS.CONFIRMER_MOT_DE_PASSE' | translate }}</ion-label>
          <ion-input (ionBlur)="checkOnBlur2()" name="plainPassword2" required [(ngModel)]="model.plainPassword2"  [ngClass] = "{'ng-invalid': error.password, 'ng-dirty': error.password, 'emailvalidation': !validation2 && userstatus2}" [type]="this.showPassword2 ? 'text' : 'password'" #plainPassword2 = "ngModel"></ion-input>
        </ion-item>
        <div class="eye-wrapper">
          <span [ngClass]= "{ 'eye': true, 'eye-crossed': this.showPassword2 }" (click)="togglePassword(2)"></span>
        </div>
        <div class="errortext" [ngClass]= "{'visible': error.password}">{{error.message}}</div>
        <div class="errortext" [ngClass]= "{'visible': !validation2 && userstatus2}">{{ 'ERROR.RESET_PASSWORD.PASSWORD_REPEAT' | translate }}</div>
        <div class="errortextpassword" [hidden]= "plainPassword2.valid || plainPassword2.pristine">{{ 'ERROR.LOGIN.REQUIRED' | translate }}</div>

        <ion-item lines="none" class="info blue-item ion-no-padding">
          <ion-checkbox class="info" [(ngModel)]="model.infoPlaybac" name="infoPlaybac"></ion-checkbox>
          <ion-label [innerHTML]= "'ACCOUNT_CREATION.LABELS.LES_INFO_PLAY_BAC' | translate"></ion-label>
        </ion-item>
        <ion-item lines="none" class="info blue-item ion-no-padding">
          <ion-checkbox class="info" [(ngModel)]="model.infoPartners" name="infoPartners"></ion-checkbox>
          <ion-label [innerHTML]= "'ACCOUNT_CREATION.LABELS.LES_INFO_PARTENAIRES' | translate"></ion-label>
        </ion-item>
        <button class="connect button" [disabled]="!firstName.valid || !lastName.valid || !validation || !plainPassword.valid" (click)="createAccount()">
          <img class="nextstep" src="../../../assets/img/next-step-icon.png">
          <div class="next">{{ 'ACCOUNT_CREATION.ETAPE_SUIVANTE' | translate }}</div>
          <div class="ion-text-left">{{ 'ACCOUNT_CREATION.CREER_PROFILS' | translate }}</div>
        </button>
      </form>
    </ion-list>
    <ion-item lines="none" class="conditions blue-item ion-no-padding">
      <ion-label [innerHTML] = "'ACCOUNT_CREATION.CLICK_ETAPE_SUIVANTE' | translate"> </ion-label>
    </ion-item>
    <ion-item lines="none" class="terms blue-item ion-no-padding">
      <ion-label [innerHTML] = "'ACCOUNT_CREATION.EMAIL_DISCLAIMER' | translate"> </ion-label>
    </ion-item>
    <ion-item lines="none" class="already blue-item ion-no-padding">
      <ion-label [innerHTML] = "'ACCOUNT_CREATION.DEJA_INSCRIT' | translate"> </ion-label>
    </ion-item>
    <ion-item lines="none" (click) = "goToLogin()" class="already blue-item ion-no-padding">
      <ion-label [innerHTML] = "'HEADER.SE_CONNECTER' | translate"> </ion-label>
    </ion-item>
  </div>
</ion-content>
<ion-footer> <app-bottom-menu></app-bottom-menu></ion-footer>
